import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import cat1 from '../../assets/Images/second/1.png'
import cat2 from '../../assets/Images/second/2.png'
import cat3 from '../../assets/Images/second/3.png'
import cat4 from '../../assets/Images/second/4.png'
import cat5 from '../../assets/Images/second/5.png'
import cat6 from '../../assets/Images/second/6.png'
import cat7 from '../../assets/Images/second/7.png'
import cat8 from '../../assets/Images/second/8.png'
import cat9 from '../../assets/Images/second/9.png'
import cat10 from '../../assets/Images/second/10.png'
import cat11 from '../../assets/Images/second/11.png'
import cat12 from '../../assets/Images/second/12.png'
import cat13 from '../../assets/Images/second/13.png'
import cat14 from '../../assets/Images/second/14.png'
import cat15 from '../../assets/Images/second/15.png'
import cat16 from '../../assets/Images/second/16.png'
import cat17 from '../../assets/Images/second/17.png'
import cat18 from '../../assets/Images/second/18.png'
import cat19 from '../../assets/Images/second/19.png'
import third1 from '../../assets/Images/featured/1.png'
import third2 from '../../assets/Images/featured/2.png'
import "./home.css"

// slick-carousel CSS
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow next-arrow" onClick={onClick}>
      <FaChevronRight color="#fff" size={20} />
    </div>
  );
}

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow prev-arrow" onClick={onClick}>
      <FaChevronLeft color="#fff" size={20} />
    </div>
  );
}

function FirstCarousel() {
  // Array of category objects
  const categories = [
    { name: 'Womens Dress', keyword: 'Womens Dress', image: cat1 },
    { name: 'Toys', keyword: 'Toys', image: cat2 },
    { name: 'Deodorants', keyword: 'Deodorants', image: cat3 },
    { name: 'Unisex Footwear', keyword: 'Unisex Footwear', image: cat4 },
    { name: 'Socks', keyword: 'Socks', image: cat5 },
    { name: 'Personal Care', keyword: 'Personal Care', image: cat6 },
    { name: 'Home and Kitchen', keyword: 'Kitchenware', image: cat7 },
    { name: 'Womens Tops', keyword: 'Womens Tops', image: cat8 },
    { name: 'Cotton Mask', keyword: 'Cotton Mask', image: cat9 },
    { name: 'Womens T-Shirts', keyword: 'Womens T-Shirts', image: cat10 },
    { name: 'Night Wears', keyword: 'Night Wears', image: cat11 },
    { name: 'Mobile Case Cover', keyword: 'Mobile Case Cover', image: cat12 },
    { name: 'Mugs', keyword: 'Mugs', image: cat13 },
    { name: 'Bags and Wallet', keyword: 'Bags and Wallet', image: cat14 },
    { name: 'Jewels', keyword: 'Jewels', image: cat15 },
    { name: 'Bedding', keyword: 'Bedding', image: cat16 },
    { name: 'Hanging Wall Art', keyword: 'Hanging Wall Art', image: cat17 },
    { name: 'Kids Footwear', keyword: 'Kids Footwear', image: cat18 },
    { name: 'Kids Dress', keyword: 'Kids Dress', image: cat19 },
    // Add more categories as needed
  ];

  const settings = {
    dots: true,            
    infinite: true,        
    speed: 800,            
    slidesToShow: 1,       
    slidesToScroll: 1,     
    autoplay: true,        
    autoplaySpeed: 5000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    fade: true,
    cssEase: 'linear',
    pauseOnHover: false
  };

  return (
   <div className='home-page'>
    <section className="hero-section">
      <div className="hero-wrapper">
        <Slider {...settings} className="hero-slider">
          <div className="hero-slide slide-1">
            <div className="hero-overlay"></div>
            <div className="hero-container">
              <div className="hero-content">
                <span className="hero-badge">Limited Time Offer</span>
                <h1 className="hero-title">Season's <br/>Best Deals</h1>
                <p className="hero-subtitle">Discover top products at unbeatable prices. <br/>Up to 50% off on selected items.</p>
                <Link to="/products?productCategory=Womens%20Dress" className="hero-btn white-btn">
                  Shop Now
                </Link>
              </div>
            </div>
          </div>
          <div className="hero-slide slide-2">
            <div className="hero-overlay"></div>
            <div className="hero-container">
              <div className="hero-content">
                <span className="hero-badge">New Arrival</span>
                <h1 className="hero-title">Playtime <br/>Adventures</h1>
                <p className="hero-subtitle">Explore our latest interactive toy collection. <br/>Fuel their imagination with every play.</p>
                <Link to="/products?productCategory=Toys" className="hero-btn white-btn">
                  Explore Collection
                </Link>
              </div>
            </div>
          </div>
          <div className="hero-slide slide-3">
            <div className="hero-overlay"></div>
            <div className="hero-container">
              <div className="hero-content">
                <span className="hero-badge">Special Edition</span>
                <h1 className="hero-title">Smart <br/>Solutions</h1>
                <p className="hero-subtitle">Explore our special home comfort appliance collection.Upgrade your everyday living.</p>
                <Link to="/products?productCategory=Kitchenware" className="hero-btn white-btn">
                  View Collection
                </Link>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>

    <section className='categories-section'>
      <div className='categories-container'>
        <div className="section-header">
          <h2 className="section-title">Shop by Category</h2>
          <p className="section-subtitle">Find exactly what you're looking for</p>
        </div>
        <div className='category-grid'>
          {categories.map(cat => (
            <Link 
              className='category-card' 
              to={`/products?productCategory=${encodeURIComponent(cat.keyword)}`} 
              key={cat.name}
            >
              <div className="category-image-wrapper">
                <img src={cat.image} alt={cat.name} className="category-image" />
              </div>
              <p className="category-name">{cat.name}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>

    <section className='featured-section'>
      <div className='featured-container'>
        <div className="section-header">
          <h2 className="section-title">Featured Collections</h2>
          <p className="section-subtitle">Curated picks just for you</p>
        </div>
        <div className='featured-grid'>
          <Link to={`/products?keyword=${encodeURIComponent('kitchen')}`} className='featured-card'>
            <div className="featured-img-wrap">
              <img src={third1} alt='Kitchen Collection'/>
            </div>
            <div className="featured-overlay">
                <div className='featured-tag'>Top Picks</div>
                <div className='featured-info'>
                    <h3 className='featured-title'>Kitchen Essentials</h3>
                    <p className='featured-desc'>Upgrade your cooking game with our latest kitchenware.</p>
                    <div className='featured-cta'>
                        <span>Shop Now</span>
                        <FaChevronRight />
                    </div>
                </div>
            </div>
          </Link>
          <Link to={`/products?keyword=${encodeURIComponent('wallet')}`} className='featured-card'>
            <div className="featured-img-wrap">
                <img src={third2} alt='Wallet Collection'/>
            </div>
            <div className="featured-overlay">
                <div className='featured-tag'>New Arrivals</div>
                <div className='featured-info'>
                    <h3 className='featured-title'>Wallets & Accessories</h3>
                    <p className='featured-desc'>Discover stylish and functional wallets for every occasion.</p>
                    <div className='featured-cta'>
                        <span>Shop Now</span>
                        <FaChevronRight />
                    </div>
                </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  </div>
  );
}

export default FirstCarousel;
